export const MOBILE_RELEASE_CENTER_BASE = '/mobile-release-center';

export const MOBILE_RELEASE_CENTER_TABS = [
  { id: 'overview', to: `${MOBILE_RELEASE_CENTER_BASE}/overview` },
  { id: 'candidates', to: `${MOBILE_RELEASE_CENTER_BASE}/candidates` },
  { id: 'plan', to: `${MOBILE_RELEASE_CENTER_BASE}/plan` },
  { id: 'content', to: `${MOBILE_RELEASE_CENTER_BASE}/content` },
  { id: 'company-web-history', to: `${MOBILE_RELEASE_CENTER_BASE}/company-web-history` },
  { id: 'releases', to: `${MOBILE_RELEASE_CENTER_BASE}/releases` },
  { id: 'versions', to: `${MOBILE_RELEASE_CENTER_BASE}/versions` },
  { id: 'policies', to: `${MOBILE_RELEASE_CENTER_BASE}/policies` },
];

export const MOBILE_RELEASE_CENTER_LEGACY_ROUTES = {
  '/release-queue': `${MOBILE_RELEASE_CENTER_BASE}/candidates`,
  '/mobile-release': `${MOBILE_RELEASE_CENTER_BASE}/releases`,
  '/app-version': `${MOBILE_RELEASE_CENTER_BASE}/versions`,
  '/app-version-policy': `${MOBILE_RELEASE_CENTER_BASE}/policies`,
};

export function getMobileReleaseCenterTab(pathname) {
  const segment = pathname.split('/').filter(Boolean)[1] || 'overview';
  if (segment === 'policy') return pathname.endsWith('/policies') ? 'policies' : 'versions';
  if (segment === 'plan' && pathname.endsWith('/candidates')) return 'candidates';
  return MOBILE_RELEASE_CENTER_TABS.some(({ id }) => id === segment) ? segment : 'overview';
}
